import styled from 'styled-components';

type InformationBannerProps = {
  backgroundColor?: string;
  ellipseColor?: string;
  title?: string;
  description?: string;
  iconImageUrl: string;
  onClick: () => void;
};

const InFormationBanner = ({
  backgroundColor,
  ellipseColor,
  title,
  description,
  iconImageUrl,
  onClick,
}: InformationBannerProps) => {
  return (
    <BannerWrapper backgroundColor={backgroundColor} onClick={onClick}>
      <Ellipse ellipseColor={ellipseColor} />
      <ContentsWrapper>
        <img
          src={iconImageUrl}
          width={160}
          height={160}
          style={{
            position: 'absolute',
            left: 0,
          }}
        />
        <TextWrapper>
          <Title>{title}</Title>
          <Description>{description}</Description>
          <Button>바로가기</Button>
        </TextWrapper>
      </ContentsWrapper>
    </BannerWrapper>
  );
};

export default InFormationBanner;

const BannerWrapper = styled.div<{ backgroundColor?: string }>`
  position: relative;
  padding: 40px;
  width: 588px;
  align-items: center;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : 'transparent'};
  border-radius: 8px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.24);
  overflow: hidden;
  cursor: pointer;
`;

const ContentsWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: end;
  align-items: center;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Ellipse = styled.div<{ ellipseColor?: string }>`
  position: absolute;
  left: -46px;
  bottom: -151px;
  width: 310px;
  height: 310px;
  background: ${({ ellipseColor }) =>
    ellipseColor ? ellipseColor : 'transparent'};
  border-radius: 50%;
  z-index: 0;
`;

const Title = styled.p`
  color: #eee;
  text-align: right;
  font-size: 30px;
  font-weight: 800;
  line-height: normal;
  letter-spacing: -0.45px;
  padding-bottom: 6px;
`;

const Description = styled.p`
  color: #e5e5e5;
  text-align: right;
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.27px;
  padding-bottom: 20px;
`;

const Button = styled.p`
  color: #eee;
  text-align: right;
  font-size: 18px;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.27px;
  text-decoration-line: underline;
  cursor: pointer;
`;
